<template>
  <section class="banner-free-tour">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-12 m-bottom" @click="redirectBanner(path1.url)">
          <img
            class="img1"
            :src="path1.image"
            :alt="translate.freeTour"
            width="913"
            height="522"
            loading="lazy"
          />
        </div>
        <div
          class="col-lg-4 col-12 d-flex justify-content-end"
          @click="redirectBanner(path2.url)"
        >
          <img
            class="img2"
            :src="path2.image"
            :alt="translate.subscribe"
            width="288"
            height="522"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import translateMain from "@/tradutors/menu";
import { isMobile } from "@/shared/utils/mobile";

const props = defineProps(["path1", "path2"]);
const route = useRoute();
const translate = computed(() =>
  route.params.language == "pt-br" ? translateMain.portugues : translateMain.ingles
);

function redirectBanner(url: string) {
  window.location.href = url;
}
</script>
<style scoped lang="css">
.img1 {
  width: 913px;
  height: 522px;
  cursor: pointer;
}
.img2 {
  width: 288px;
  height: 522px;
  cursor: pointer;
}

.row {
  margin-top: 50px;
  padding-bottom: 48px;
}

/* até 1199px (inclui faixa tablet/iPad) as imagens são fluidas; acima disso voltam
   ao tamanho fixo do desktop. Antes parava em 992px e estourava em 993–1199px. */
@media screen and (max-width: 1199px) {
  .img1 {
    width: 100%;
    object-fit: fill;
    height: auto;
  }
  .img2 {
    width: 100%;
    object-fit: fill;
    height: auto;
  }
  .m-bottom {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 769px) {
  .banner-free-tour {
    background-color: #000000;
  }
  /* container/row em largura total para o gradiente cinza preencher até as
     bordas (sem faixas pretas laterais). O padding das colunas é mantido,
     então as imagens continuam com espaçamento nas extremidades. */
  .banner-free-tour .container {
    padding-left: 0;
    padding-right: 0;
    max-width: 100%;
  }
  .banner-free-tour .m-bottom {
    background: linear-gradient(to bottom, #F0F0F0 0 50%, transparent 50%);
    top: -1px;
  }
  .banner-free-tour .img1,
  .banner-free-tour .img2 {
    width: 95%;
    display: block;
    margin: 0 auto;
  }
  .row {
    margin-top: 0px;
    margin-left: 0;
    margin-right: 0;
    padding-bottom: 10px;
  }
}
</style>
